// client/src/hooks/useFranquias.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
// ✅ CORREÇÃO: Importa a sua instância configurada 'apiClient' (que é a exportação padrão de api.js).
import api from '../services/api';
import useAlert from './useAlert';

const FRANQUIAS_QUERY_KEY = 'franquias';

/**
 * Hook para buscar uma lista de franquias.
 */
export const useFranquias = (params) => {
    return useQuery({
        queryKey: [FRANQUIAS_QUERY_KEY, params],
        queryFn: async () => {
            // ✅ CORREÇÃO: Usa 'api' em vez de 'axios'.
            const { data } = await api.get('/franquias', { params });
            return data.data; // Retorna o array de franquias
        },
        placeholderData: (previousData) => previousData,
    });
};

/**
 * Hook para buscar uma única franquia pelo ID. Útil para formulários de edição.
 */
export const useFranquiaById = (id, options = {}) => {
    return useQuery({
        queryKey: [FRANQUIAS_QUERY_KEY, id],
        queryFn: async () => {
            if (!id) return null;
            // ✅ CORREÇÃO: Usa 'api' em vez de 'axios'.
            const { data } = await api.get(`/franquias/${id}`);
            return data.data;
        },
        enabled: !!id && (options.enabled !== undefined ? options.enabled : true),
    });
};

/**
 * Hook que retorna as funções de mutação (criar, atualizar, deletar) para Franquias.
 */
export const useMutateFranquias = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();

    const invalidateCache = () => {
        queryClient.invalidateQueries({ queryKey: [FRANQUIAS_QUERY_KEY] });
    };

    const createFranquia = useMutation({
        // ✅ CORREÇÃO: Usa 'api' em vez de 'axios'.
        mutationFn: (franquiaData) => api.post('/franquias', franquiaData),
        onSuccess: () => {
            invalidateCache();
            setAlert('Franquia criada com sucesso!', 'success');
        },
        onError: (err) => setAlert(err.response?.data?.error || 'Erro ao criar franquia', 'danger'),
    });

    const updateFranquia = useMutation({
        // ✅ CORREÇÃO: Usa 'api' em vez de 'axios'.
        mutationFn: ({ id, franquiaData }) => api.put(`/franquias/${id}`, franquiaData),
        onSuccess: (data, variables) => {
            invalidateCache();
            queryClient.invalidateQueries({ queryKey: [FRANQUIAS_QUERY_KEY, variables.id] });
            setAlert('Franquia atualizada com sucesso!', 'success');
        },
        onError: (err) => setAlert(err.response?.data?.error || 'Erro ao atualizar franquia', 'danger'),
    });

    const deleteFranquia = useMutation({
        mutationFn: (id) => {
            if (window.confirm('Tem certeza? Esta ação não pode ser desfeita.')) {
                // ✅ CORREÇÃO: Usa 'api' em vez de 'axios'.
                return api.delete(`/franquias/${id}`);
            }
            return Promise.reject('Ação cancelada');
        },
        onSuccess: () => {
            invalidateCache();
            setAlert('Franquia removida com sucesso!', 'success');
        },
        onError: (err) => {
            if (err !== 'Ação cancelada') {
                setAlert(err.response?.data?.error || 'Erro ao remover franquia', 'danger');
            }
        },
    });

    return { createFranquia, updateFranquia, deleteFranquia };
};